import React from 'react';

const LabBench: React.FC = () => (
  <group position={[0, -1.72, 0]}>
    <mesh rotation={[-Math.PI / 2, 0, 0]}>
      <planeGeometry args={[8, 5]} />
      <meshStandardMaterial color="#d8dce0" roughness={0.8} metalness={0.05} transparent opacity={0.4} />
    </mesh>
  </group>
);

export default LabBench;